import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useCurrentCarAnnouncementSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useCurrentCarAnnouncementAuctionResume() {
  const { startListen } = useWebSocketStore()
  const { updateAnnouncementCarData } = useUpdateCar()

  const auctionResume = () => {
    startListen({
      eventName: 'premium.AUCTION_RESUME',
      callbackName: CURRENT_CAR_ANNOUNCEMENT_SOCKET_CALLBACK,
      callback: (event) => {
        const { auctionId, resumeTime } = event.context

        updateAnnouncementCarData(auctionId, (item) => {
          if (!item) {
            return item
          }

          const newTime = new Date(resumeTime * 1000).toISOString()

          return {
            ...item,
            pausedHotbidStartTime: null,
            auctionStartDate: newTime,
            hotbidStartTime: newTime,
          }
        })
      },
    })
  }

  return { auctionResume }
}
